import { render } from "./DashboardComponent.vue?vue&type=template&id=4e61291f"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=4e61291f&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__